import { SearchQuery } from '../../common';
import { QueryParamsGroups } from './urlFilters.types';
import { urlFilterParamGroupNames } from './urlFiltersConfig';

export const serializeUrlParams = (searchQuery: SearchQuery): string => {
  const paramGroups = searchQuery.reduce<QueryParamsGroups>(
    (groups, entity) => {
      if ('complexity' in entity) {
        groups.complexities.push(entity.complexity);
      }

      if ('category' in entity) {
        groups.categories.push(entity.category);
      }

      if ('text' in entity) {
        groups.texts.push(entity.text);
      }

      return groups;
    },
    {
      complexities: [],
      categories: [],
      texts: [],
    }
  );
  const groups: Record<string, string> = {};

  if (paramGroups.complexities.length) {
    groups[urlFilterParamGroupNames.complexities] = paramGroups.complexities.join(',');
  }

  if (paramGroups.categories.length) {
    groups[urlFilterParamGroupNames.categories] = paramGroups.categories.join(',');
  }

  if (paramGroups.texts.length) {
    groups[urlFilterParamGroupNames.texts] = paramGroups.texts.join(',');
  }

  const urlQueryString = new URLSearchParams(groups).toString();
  return urlQueryString ? `?${urlQueryString}` : '';
};
